import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withVariants } from './util';
const Medium = (_jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", id: "Layer_1", "data-name": "Layer 1", viewBox: "0 0 18 18" }, { children: [_jsx("path", { fill: "#445560", d: "M3.39.18a.73.73,0,0,0-.73.73V17.09a.73.73,0,0,0,.73.73.74.74,0,0,0,.74-.73V.91A.74.74,0,0,0,3.39.18Z" }, void 0), _jsx("path", { fill: "red", d: "M15.36,1.43a3.79,3.79,0,0,1-.61.71c-.61.41-1.9.81-5-.88a6.32,6.32,0,0,0-6.8.55L2.64,2v8.48l1.18-.9A5.14,5.14,0,0,1,9,9.21c2.39,1.17,4.48,1.45,5.61.75a1.43,1.43,0,0,0,.72-1.21Z" }, void 0)] }), void 0));
export const variants = {
    medium: Medium,
    default: Medium,
};
export default withVariants(variants);
